import { render } from "./VoteActivityItem.vue?vue&type=template&id=57d0d332&scoped=true"
import script from "./VoteActivityItem.vue?vue&type=script&lang=js"
export * from "./VoteActivityItem.vue?vue&type=script&lang=js"

import "./VoteActivityItem.vue?vue&type=style&index=0&id=57d0d332&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-57d0d332"

export default script